<template>
    <header class="agent-chat__header">
        <div class="agent-chat__header-main">
            <span class="agent-chat__title">{{ title }}</span>
            <div v-if="agents.length || providers.length" class="agent-chat__selectors">
                <select
                    v-if="agents.length && !agentLocked"
                    class="agent-chat__select"
                    :value="selectedAgent"
                    aria-label="Agente"
                    @change="$emit('update:selectedAgent', $event.target.value)"
                >
                    <option
                        v-for="agent in agents"
                        :key="agent.slug"
                        :value="agent.slug"
                    >
                        {{ agent.label }}
                    </option>
                </select>
                <select
                    v-if="providers.length && !llmLocked"
                    class="agent-chat__select"
                    :value="selectedProvider"
                    aria-label="Provider"
                    @change="$emit('update:selectedProvider', $event.target.value)"
                >
                    <option
                        v-for="provider in providers"
                        :key="provider.key"
                        :value="provider.key"
                    >
                        {{ provider.label }}
                    </option>
                </select>
                <select
                    v-if="providers.length && !llmLocked"
                    class="agent-chat__select"
                    :value="selectedModel"
                    aria-label="Modello"
                    @change="$emit('update:selectedModel', $event.target.value)"
                >
                    <option
                        v-for="model in models"
                        :key="model.id"
                        :value="model.id"
                    >
                        {{ model.label }}
                    </option>
                </select>
            </div>
        </div>
        <button
            v-if="showClose"
            type="button"
            class="agent-chat__close"
            aria-label="Chiudi"
            @click="$emit('close')"
        >&times;</button>
        <button
            v-if="showNewChat"
            type="button"
            class="agent-chat__new-chat"
            @click="$emit('new-chat')"
        >
            Nuova chat
        </button>
    </header>
</template>

<script>
export default {
    name: 'AgentChatHeader',
    props: {
        title: {
            type: String,
            default: 'AI Assistant',
        },
        agents: {
            type: Array,
            default: () => [],
        },
        selectedAgent: {
            type: String,
            default: '',
        },
        providers: {
            type: Array,
            default: () => [],
        },
        models: {
            type: Array,
            default: () => [],
        },
        selectedProvider: {
            type: String,
            default: '',
        },
        selectedModel: {
            type: String,
            default: '',
        },
        showClose: {
            type: Boolean,
            default: false,
        },
        showNewChat: {
            type: Boolean,
            default: false,
        },
        agentLocked: {
            type: Boolean,
            default: false,
        },
        llmLocked: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:selectedAgent', 'update:selectedProvider', 'update:selectedModel', 'close', 'new-chat'],
};
</script>

<style scoped>
.agent-chat__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    padding: 12px 16px;
    border-bottom: 1px solid #e2e8f0;
    background: #f8fafc;
}

.agent-chat__header-main {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
    flex: 1 1 auto;
}

.agent-chat__title {
    font-weight: 600;
    font-size: 14px;
    color: #0f172a;
}

.agent-chat__selectors {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.agent-chat__select {
    max-width: 100%;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    padding: 4px 8px;
    font-size: 12px;
    background: #fff;
    color: #0f172a;
}

.agent-chat__close {
    flex: 0 0 auto;
    border: none;
    background: transparent;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
    color: #475569;
}

.agent-chat__new-chat {
    flex: 0 0 auto;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    background: #fff;
    padding: 4px 10px;
    font-size: 12px;
    cursor: pointer;
    color: #0f172a;
}
</style>
